import * as type from '../actions/types';

const initialState = {
  saving: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.TOGGLE_MENU_ITEM_STOCK_PENDING: {
      return {
        ...state,
        saving: true,
        error: false,
        errorMessage: '',
      };
    }
    case type.TOGGLE_MENU_ITEM_STOCK_SUCCESS: {
      return {
        ...state,
        saving: false,
        success: true,
      };
    }
    case type.TOGGLE_MENU_ITEM_STOCK_FAILURE: {
      return {
        ...state,
        saving: false,
        error: true,
        errorMessage: action.payload,
      };
    }
    case type.CLEAR_TOGGLE_MENU_ITEM_STOCK: {
      return {
        ...state,
        saving: false,
        error: false,
        errorMessage: '',
        success: false,
      };
    }

    default: {
      return state;
    }
  }
};
